import React from "react";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";

import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";

import axios from "../../api/axios";

const ServiceTask = () => {
  const state = useSelector((state) => state.UserReducer);
  const navigate = useNavigate();
  const serviceTaskUrl = "/servicetask";

  const [refreshData, setRefreshData] = React.useState(false);
  const [serviceTaskData, setServiceTaskData] = React.useState([]);
  const [serviceTaskServerData, setServiceTaskServerData] = React.useState([]);
  const [currentPageIndex, setCurrentPageIndex] = React.useState(0);
  const [totalPages, setTotalPages] = React.useState(1);
  const getServiceTask = (query) => {
    try {
      axios
        .get(serviceTaskUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          setRefreshData(true);
          if (response?.data?.serviceTask?.length >= 0) {
            setServiceTaskData(response.data.serviceTask);
            setServiceTaskServerData(response.data.serviceTask);
          }
        })
        .catch((err) => {
          setRefreshData(true);
          toast.error("Something went wrong");
        });
    } catch (err) {
      setRefreshData(true);
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [newTasks, setNewTasks] = React.useState([]);
  const [assignedTasks, setAssignedTasks] = React.useState([]);
  const [inServiceTasks, setInServiceTasks] = React.useState([]);
  const [doneTasks, setDoneTasks] = React.useState([]);
  const [cancelledTasks, setCancelledTasks] = React.useState([]);
  const [todaysTasks, setTodaysTasks] = React.useState([]);

  React.useEffect(() => {
    const newTasksFiltered = serviceTaskData.filter((item) => {
      return item?.status === "NEW";
    });
    setNewTasks(newTasksFiltered);
    const assignedTasksFiltered = serviceTaskData.filter((item) => {
      return item?.status === "ASSIGNED";
    });
    setAssignedTasks(assignedTasksFiltered);
    const inServiceTasksFiltered = serviceTaskData.filter((item) => {
      return item?.status === "IN-PROCESS";
    });
    setInServiceTasks(inServiceTasksFiltered);
    const doneTasksFiltered = serviceTaskData.filter((item) => {
      return item?.status === "DONE";
    });
    setDoneTasks(doneTasksFiltered);
    const cancelledTasksFiltered = serviceTaskData.filter((item) => {
      return item?.status === "CANCELLED";
    });
    setCancelledTasks(cancelledTasksFiltered);
    const todaysTasksFiltered = serviceTaskData.filter((item) => {
      return (
        item?.status !== "DONE" &&
        item?.status !== "CANCELLED" &&
        moment.utc(item?.dueDate).local().diff(Date.now(), "days") === 0 &&
        item?.assignee?._id === state.user._id
      );
    });
    setTodaysTasks(todaysTasksFiltered);
  }, [serviceTaskData]);

  const searchServiceTask = (queryString) => {
    var query = queryString.trim().split(" ");
    if (query.length > 0) {
      const tempServiceTaskData = serviceTaskServerData.filter((item) => {
        const superText = (
          item?.serviceTicketId?.serviceTicketID +
          " " +
          item?.serviceTaskID +
          " " +
          Date(item?.dueDate).slice(0, 10) +
          ". " +
          item?.assignee.fullname +
          " " +
          item?.createdBy.fullname +
          " " +
          item?.name
        ).toLowerCase();
        return query.every((element) => {
          return superText.includes(element);
        });
      });
      setServiceTaskData(tempServiceTaskData);
    } else {
      setServiceTaskData(serviceTaskServerData);
    }
  };

  const renderStatus = (status) => {
    switch (status) {
      case "NEW":
        return (
          <span className='bg-blue-100 text-blue-800 text-xs font-semibold px-1.5 py-0.5 rounded dark:bg-blue-200 dark:text-blue-800'>
            NEW
          </span>
        );
      case "ASSIGNED":
        return (
          <span className='bg-orange-100 text-orange-800 text-xs font-semibold px-1.5 py-0.5 rounded dark:bg-orange-200 dark:text-orange-900'>
            ASSIGNED
          </span>
        );
      case "IN-PROCESS":
        return (
          <span className='bg-green-100 text-green-800 text-xs font-semibold px-1.5 py-0.5 rounded dark:bg-green-200 dark:text-green-900'>
            IN-PROCESS
          </span>
        );
      default:
        return (
          <span className='bg-red-100 text-red-600 text-xs font-semibold px-1.5 py-0.5 rounded dark:bg-red-200 dark:text-red-900'>
            {status.toUpperCase()}
          </span>
        );
    }
  };

  const [pageTitle, setPageTitle] = React.useState("Lands & Lands ERP");
  React.useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    getServiceTask("");
    setPageTitle("Tasks - L&L ERP");
  }, [refreshData]);

  return (
    <>
      <div className='min-h-full'>
        <main className='relative'>
          <div className='max-w-8xl mx-auto py-6 sm:px-6 lg:px-8'>
            <div className='lg:flex lg:items-center justify-between'>
              <div className='flex-1 min-w-0 px-5 lg:px-0'>
                <h2 className='mt-4 ml-1 text-xl font-semibold leading-7 text-gray-dark sm:text-xl '>
                  Service Tasks
                </h2>
              </div>
              <div className='flex mt-3 ml-4'>
                <div className='grid grid-cols-4 gap-2 justify-items-end'>
                  <div className='col-span-3 w-full'>
                    <input
                      type='text'
                      name='search'
                      id='search'
                      placeholder='Search'
                      onChange={(e) => {
                        searchServiceTask(e.target.value);
                      }}
                      maxLength='20'
                      className='focus:ring-yellow-2 focus:border-yellow-2 block w-full text-sm shadow-sm sm:text-xs read-only:bg-gray-100 read-only:opacity-50 rounded-sm'
                    />
                  </div>
                  <div>
                    <span className='sm:block'>
                      <Link to='/servicetask/create'>
                        <button
                          type='button'
                          className='inline-flex items-center px-4 py-2 border border-gray-300 rounded-sm shadow-sm text-sm sm:text-xs font-medium text-black bg-yellow hover:bg-gray-dark hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'>
                          Create
                        </button>
                      </Link>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className='pb-4 py-6 sm:px-0 hidden sm:block'>
              <div className='shadow-lg'>
                <div className='flex-col pb-2 bg-gray-50'>
                  <div className='p-4'>
                    <div className='flex space-x-4'>
                      <div className='flex py-1 px-2 text-sm font-semibold'>
                        <div className='w-3 h-3 rounded-sm mt-1 mr-2 bg-assigned-to-me'></div>
                        <p className='mt-0.25 text-assigned-to-me'>
                          Assigned To Me
                        </p>
                      </div>
                      <div className='flex py-1 px-2 text-sm font-semibold'>
                        <div className='w-3 h-3 rounded-sm mt-1 mr-2 bg-assigned-by-me'></div>
                        <p className='mt-0.25 text-assigned-by-me'>
                          Assigned By Me
                        </p>
                      </div>
                      <div className='flex py-1 px-2 text-sm font-semibold'>
                        <div className='w-3 h-3 rounded-sm mt-1 mr-2 bg-self-assigned'></div>
                        <p className='mt-0.25 text-self-assigned'>
                          Self Assigned
                        </p>
                      </div>
                    </div>
                  </div>
                  {todaysTasks.length > 0 && (
                    <div className='flex-col w-6/12 pl-4 pb-4'>
                      <div className=''>
                        <h2 className='ml-1 text-sm font-semibold leading-3 text-gray-dark sm:text-lg'>
                          Today's Spotlight
                        </h2>
                      </div>
                      <div className='flex-col space-y-2 w-full px-4 mt-1'>
                        {todaysTasks.map((item) => (
                          <div
                            key={item._id}
                            className={`flex space-x-2 justify-between px-3 py-2 bg-white hover:bg-gray-300 duration-300 rounded-md hover:rounded-sm shadow-md overflow-x-auto ${
                              item?.assignee._id === state.user._id
                                ? item?.createdBy._id === state.user._id
                                  ? "border-l-8 border-self-assigned"
                                  : "border-l-8 border-assigned-to-me"
                                : ""
                            } ${
                              item?.createdBy._id === state.user._id &&
                              item?.assignee._id !== state.user._id
                                ? "border-l-8 border-assigned-by-me"
                                : ""
                            }`}
                            onClick={(e) => {
                              navigate("/servicetask/" + item._id);
                            }}>
                            <div className=''>
                              <span
                                className={`font-semibold text-sm ${
                                  item?.assignee._id === state.user._id
                                    ? item?.createdBy._id === state.user._id
                                      ? "text-self-assigned"
                                      : "text-assigned-to-me"
                                    : ""
                                } ${
                                  item?.createdBy._id === state.user._id &&
                                  item?.assignee._id !== state.user._id
                                    ? "text-assigned-by-me"
                                    : ""
                                } mr-2`}>
                                #{item.serviceTaskID}
                              </span>
                              <span className='font-semibold text-sm text-gray-dark cursor-default'>
                                {item.name.slice(0, 50)}
                              </span>
                            </div>
                            <div className='flex justify-end font-semibold text-xs rounded-md text-gray-dark'>
                              <span className='mt-1'>
                                {item.dueDate
                                  ?.toString()
                                  .slice(0, 16)
                                  .replace("T", " ")}
                              </span>
                              {moment(item?.dueDate.toString().slice(0, 19))
                                // .local()
                                .diff(Date.now(), "minutes") < 0 &&
                                !item.status.includes("DONE", "CANCELLED") && (
                                  <div className='font-semibold pl-2 animate-pulse rounded-md leading-5'>
                                    <span className='bg-red-100 text-red-200 text-xs font-semibold px-1.5 py-0.5 rounded dark:bg-red-800'>
                                      OVERDUE
                                    </span>
                                  </div>
                                )}
                              <div className='ml-2 mt-0.5'>
                                {renderStatus(item.status)}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  <div className='flex space-x-2 px-3 justify-between overflow-x-auto'>
                    <div className='flex-col w-full bg-yellow-50 py-3'>
                      <div className='text-sm font-semibold text-gray-700 px-4'>
                        NEW
                      </div>
                      {refreshData ? (
                        newTasks.length > 0 ? (
                          <div className='mt-2'>
                            {newTasks.map((item) => (
                              <div
                                key={item?._id}
                                className={`bg-white hover:bg-gray-300 duration-200 mx-2 mb-2 px-3 py-2 cursor-default rounded-sm border-gray-100 flex-col ${
                                  item?.assignee._id === state.user._id
                                    ? item?.createdBy._id === state.user._id
                                      ? "border-l-8 border-self-assigned"
                                      : "border-l-8 border-assigned-to-me"
                                    : ""
                                } ${
                                  item?.createdBy._id === state.user._id &&
                                  item?.assignee._id !== state.user._id
                                    ? "border-l-8 border-assigned-by-me"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  navigate("/servicetask/" + item?._id);
                                }}>
                                <div className='flex justify-between'>
                                  <div className='flex'>
                                    <span
                                      className={`font-semibold text-sm ${
                                        item?.assignee._id === state.user._id
                                          ? item?.createdBy._id ===
                                            state.user._id
                                            ? "text-self-assigned"
                                            : "text-assigned-to-me"
                                          : ""
                                      } ${
                                        item?.createdBy._id ===
                                          state.user._id &&
                                        item?.assignee._id !== state.user._id
                                          ? "text-assigned-by-me"
                                          : ""
                                      } mr-2`}>
                                      #{item?.serviceTaskID}
                                    </span>
                                    {/* {renderStatus(item?.status)} */}
                                  </div>
                                  <span className='font-semibold text-xs text-gray-dark text-right'>
                                    Service - #
                                    {item?.serviceTicketId?.serviceTicketID +
                                      (item?.serviceTicketId?.addressBookId
                                        ? " | " +
                                          item?.serviceTicketId?.addressBookId
                                            ?.prefix +
                                          ". " +
                                          item?.serviceTicketId?.addressBookId
                                            ?.firstName
                                        : "")}
                                  </span>
                                </div>
                                <div className='flex justify-between py-1'>
                                  <span className='font-semibold text-sm text-gray-dark'>
                                    {item?.name}
                                  </span>
                                </div>
                                <div className='flex justify-between mt-1'>
                                  <div className='flex mt-1'>
                                    <span className='font-semibold text-xs '>
                                      {moment
                                        .utc(item?.dueDate)
                                        .local()
                                        .format("yyyy-MM-DD HH:mm")}
                                    </span>
                                    {moment
                                      .utc(item?.dueDate)
                                      .local()
                                      .diff(Date.now(), "minutes") < 0 && (
                                      <img
                                        className={`h-5 w-5 ml-1.5`}
                                        src={`/assets/icons/task-overdue.png`}
                                        alt='Task Overdue'
                                      />
                                    )}
                                  </div>
                                  <div className='flex space-x-2 pb-1'>
                                    <img
                                      src={
                                        item?.createdBy?.avatar
                                          ? item?.createdBy?.avatar
                                          : "/assets/images/user.png"
                                      }
                                      alt='User'
                                      title={
                                        "Reportee - " +
                                        item?.createdBy?.fullname
                                      }
                                      referrerPolicy='no-referrer'
                                      className='h-7 w-7 rounded-full ring-1 ring-yellow-2'
                                    />
                                    <img
                                      src={
                                        item?.assignee?.avatar
                                          ? item?.assignee?.avatar
                                          : "/assets/images/user.png"
                                      }
                                      alt='User'
                                      title={
                                        "Assignee - " + item?.assignee?.fullname
                                      }
                                      referrerPolicy='no-referrer'
                                      className='h-7 w-7 rounded-full ring-1 ring-yellow-2'
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className='font-semibold'></div>
                        )
                      ) : (
                        <span className='mt-1 block w-full px-3 text-sm'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-gray-100 h-6 rounded-sm '></div>
                          </div>
                        </span>
                      )}
                    </div>
                    <div className='flex-col w-full bg-yellow-50 py-3'>
                      <div className='text-sm font-semibold text-gray-700 px-4'>
                        ASSIGNED
                      </div>
                      {refreshData ? (
                        assignedTasks.length > 0 ? (
                          <div className='mt-2'>
                            {assignedTasks.map((item) => (
                              <div
                                key={item?._id}
                                className={`bg-white hover:bg-gray-300 duration-200 mx-2 mb-2 px-3 py-2 cursor-default rounded-sm border-gray-100 flex-col ${
                                  item?.assignee._id === state.user._id
                                    ? item?.createdBy._id === state.user._id
                                      ? "border-l-8 border-self-assigned"
                                      : "border-l-8 border-assigned-to-me"
                                    : ""
                                } ${
                                  item?.createdBy._id === state.user._id &&
                                  item?.assignee._id !== state.user._id
                                    ? "border-l-8 border-assigned-by-me"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  navigate("/servicetask/" + item?._id);
                                }}>
                                <div className='flex justify-between'>
                                  <div className='flex'>
                                    <span
                                      className={`font-semibold text-sm ${
                                        item?.assignee._id === state.user._id
                                          ? item?.createdBy._id ===
                                            state.user._id
                                            ? "text-self-assigned"
                                            : "text-assigned-to-me"
                                          : ""
                                      } ${
                                        item?.createdBy._id ===
                                          state.user._id &&
                                        item?.assignee._id !== state.user._id
                                          ? "text-assigned-by-me"
                                          : ""
                                      } mr-2`}>
                                      #{item?.serviceTaskID}
                                    </span>
                                    {/* {renderStatus(item?.status)} */}
                                  </div>
                                  <span className='font-semibold text-xs text-gray-dark text-right'>
                                    Service - #
                                    {item?.serviceTicketId?.serviceTicketID +
                                      (item?.serviceTicketId?.addressBookId
                                        ? " | " +
                                          item?.serviceTicketId?.addressBookId
                                            ?.prefix +
                                          ". " +
                                          item?.serviceTicketId?.addressBookId
                                            ?.firstName
                                        : "")}
                                  </span>
                                </div>
                                <div className='flex justify-between py-1'>
                                  <span className='font-semibold text-sm text-gray-dark'>
                                    {item?.name}
                                  </span>
                                </div>
                                <div className='flex justify-between mt-1'>
                                  <div className='flex mt-1'>
                                    <span className='font-semibold text-xs '>
                                      {moment
                                        .utc(item?.dueDate)
                                        .local()
                                        .format("yyyy-MM-DD HH:mm")}
                                    </span>
                                    {moment
                                      .utc(item?.dueDate)
                                      .local()
                                      .diff(Date.now(), "minutes") < 0 && (
                                      <img
                                        className={`h-5 w-5 ml-1.5`}
                                        src={`/assets/icons/task-overdue.png`}
                                        alt='Task Overdue'
                                      />
                                    )}
                                  </div>
                                  <div className='flex space-x-2 pb-1'>
                                    <img
                                      src={
                                        item?.createdBy?.avatar
                                          ? item?.createdBy?.avatar
                                          : "/assets/images/user.png"
                                      }
                                      alt='User'
                                      title={
                                        "Reportee - " +
                                        item?.createdBy?.fullname
                                      }
                                      referrerPolicy='no-referrer'
                                      className='h-7 w-7 rounded-full ring-1 ring-yellow-2'
                                    />
                                    <img
                                      src={
                                        item?.assignee?.avatar
                                          ? item?.assignee?.avatar
                                          : "/assets/images/user.png"
                                      }
                                      alt='User'
                                      title={
                                        "Assignee - " + item?.assignee?.fullname
                                      }
                                      referrerPolicy='no-referrer'
                                      className='h-7 w-7 rounded-full ring-1 ring-yellow-2'
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className='font-semibold'></div>
                        )
                      ) : (
                        <span className='mt-1 block w-full px-3 text-sm'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-gray-100 h-6 rounded-sm '></div>
                          </div>
                        </span>
                      )}
                    </div>
                    <div className='flex-col w-full bg-yellow-50 py-3'>
                      <div className='text-sm font-semibold text-gray-700 px-4'>
                        IN PROCESS
                      </div>
                      {refreshData ? (
                        inServiceTasks.length > 0 ? (
                          <div className='mt-2'>
                            {inServiceTasks.map((item) => (
                              <div
                                key={item?._id}
                                className={`bg-white hover:bg-gray-300 duration-200 mx-2 mb-2 px-3 py-2 cursor-default rounded-sm border-gray-100 flex-col ${
                                  item?.assignee._id === state.user._id
                                    ? item?.createdBy._id === state.user._id
                                      ? "border-l-8 border-self-assigned"
                                      : "border-l-8 border-assigned-to-me"
                                    : ""
                                } ${
                                  item?.createdBy._id === state.user._id &&
                                  item?.assignee._id !== state.user._id
                                    ? "border-l-8 border-assigned-by-me"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  navigate("/servicetask/" + item?._id);
                                }}>
                                <div className='flex justify-between'>
                                  <div className='flex'>
                                    <span
                                      className={`font-semibold text-sm ${
                                        item?.assignee._id === state.user._id
                                          ? item?.createdBy._id ===
                                            state.user._id
                                            ? "text-self-assigned"
                                            : "text-assigned-to-me"
                                          : ""
                                      } ${
                                        item?.createdBy._id ===
                                          state.user._id &&
                                        item?.assignee._id !== state.user._id
                                          ? "text-assigned-by-me"
                                          : ""
                                      } mr-2`}>
                                      #{item?.serviceTaskID}
                                    </span>
                                    {/* {renderStatus(item?.status)} */}
                                  </div>
                                  <span className='font-semibold text-xs text-gray-dark text-right'>
                                    Service - #
                                    {item?.serviceTicketId?.serviceTicketID +
                                      (item?.serviceTicketId?.addressBookId
                                        ? " | " +
                                          item?.serviceTicketId?.addressBookId
                                            ?.prefix +
                                          ". " +
                                          item?.serviceTicketId?.addressBookId
                                            ?.firstName
                                        : "")}
                                  </span>
                                </div>
                                <div className='flex justify-between py-1'>
                                  <span className='font-semibold text-sm text-gray-dark'>
                                    {item?.name}
                                  </span>
                                </div>
                                <div className='flex justify-between mt-1'>
                                  <div className='flex mt-1'>
                                    <span className='font-semibold text-xs '>
                                      {moment
                                        .utc(item?.dueDate)
                                        .local()
                                        .format("yyyy-MM-DD HH:mm")}
                                    </span>
                                    {moment
                                      .utc(item?.dueDate)
                                      .local()
                                      .diff(Date.now(), "minutes") < 0 && (
                                      <img
                                        className={`h-5 w-5 ml-1.5`}
                                        src={`/assets/icons/task-overdue.png`}
                                        alt='Task Overdue'
                                      />
                                    )}
                                  </div>
                                  <div className='flex space-x-2 pb-1'>
                                    <img
                                      src={
                                        item?.createdBy?.avatar
                                          ? item?.createdBy?.avatar
                                          : "/assets/images/user.png"
                                      }
                                      alt='User'
                                      title={
                                        "Reportee - " +
                                        item?.createdBy?.fullname
                                      }
                                      referrerPolicy='no-referrer'
                                      className='h-7 w-7 rounded-full ring-1 ring-yellow-2'
                                    />
                                    <img
                                      src={
                                        item?.assignee?.avatar
                                          ? item?.assignee?.avatar
                                          : "/assets/images/user.png"
                                      }
                                      alt='User'
                                      title={
                                        "Assignee - " + item?.assignee?.fullname
                                      }
                                      referrerPolicy='no-referrer'
                                      className='h-7 w-7 rounded-full ring-1 ring-yellow-2'
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className='font-semibold'></div>
                        )
                      ) : (
                        <span className='mt-1 block w-full px-3 text-sm'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-gray-100 h-6 rounded-sm '></div>
                          </div>
                        </span>
                      )}
                    </div>
                    <div className='flex-col w-full bg-yellow-50 py-3'>
                      <div className='text-sm font-semibold text-gray-700 px-4'>
                        DONE
                      </div>
                      {refreshData ? (
                        doneTasks.length > 0 ? (
                          <div className='mt-2'>
                            {doneTasks.map((item) => (
                              <div
                                key={item?._id}
                                className={`bg-white hover:bg-gray-300 duration-200 mx-2 mb-2 px-3 py-2 cursor-default rounded-sm border-gray-100 flex-col ${
                                  item?.assignee._id === state.user._id
                                    ? item?.createdBy._id === state.user._id
                                      ? "border-l-8 border-self-assigned"
                                      : "border-l-8 border-assigned-to-me"
                                    : ""
                                } ${
                                  item?.createdBy._id === state.user._id &&
                                  item?.assignee._id !== state.user._id
                                    ? "border-l-8 border-assigned-by-me"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  navigate("/servicetask/" + item?._id);
                                }}>
                                <div className='flex justify-between'>
                                  <div className='flex'>
                                    <span
                                      className={`font-semibold text-sm ${
                                        item?.assignee._id === state.user._id
                                          ? item?.createdBy._id ===
                                            state.user._id
                                            ? "text-self-assigned"
                                            : "text-assigned-to-me"
                                          : ""
                                      } ${
                                        item?.createdBy._id ===
                                          state.user._id &&
                                        item?.assignee._id !== state.user._id
                                          ? "text-assigned-by-me"
                                          : ""
                                      } mr-2`}>
                                      #{item?.serviceTaskID}
                                    </span>
                                    {/* {renderStatus(item?.status)} */}
                                  </div>
                                  <span className='font-semibold text-xs text-gray-dark text-right'>
                                    Service - #
                                    {item?.serviceTicketId?.serviceTicketID +
                                      (item?.serviceTicketId?.addressBookId
                                        ? " | " +
                                          item?.serviceTicketId?.addressBookId
                                            ?.prefix +
                                          ". " +
                                          item?.serviceTicketId?.addressBookId
                                            ?.firstName
                                        : "")}
                                  </span>
                                </div>
                                <div className='flex justify-between py-1'>
                                  <span className='font-semibold text-sm text-gray-dark'>
                                    {item?.name}
                                  </span>
                                </div>
                                <div className='flex justify-between mt-1'>
                                  <div className='flex mt-1'>
                                    <span className='font-semibold text-xs '>
                                      {moment
                                        .utc(item?.dueDate)
                                        .local()
                                        .format("yyyy-MM-DD HH:mm")}
                                    </span>
                                  </div>
                                  <div className='flex space-x-2 pb-1'>
                                    <img
                                      src={
                                        item?.createdBy?.avatar
                                          ? item?.createdBy?.avatar
                                          : "/assets/images/user.png"
                                      }
                                      alt='User'
                                      title={
                                        "Reportee - " +
                                        item?.createdBy?.fullname
                                      }
                                      referrerPolicy='no-referrer'
                                      className='h-7 w-7 rounded-full ring-1 ring-yellow-2'
                                    />
                                    <img
                                      src={
                                        item?.assignee?.avatar
                                          ? item?.assignee?.avatar
                                          : "/assets/images/user.png"
                                      }
                                      alt='User'
                                      title={
                                        "Assignee - " + item?.assignee?.fullname
                                      }
                                      referrerPolicy='no-referrer'
                                      className='h-7 w-7 rounded-full ring-1 ring-yellow-2'
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className='font-semibold'></div>
                        )
                      ) : (
                        <span className='mt-1 block w-full px-3 text-sm'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-gray-100 h-6 rounded-sm '></div>
                          </div>
                        </span>
                      )}
                    </div>
                    <div className='flex-col w-full bg-yellow-50 py-3'>
                      <div className='text-sm font-semibold text-gray-700 px-4'>
                        CANCELLED
                      </div>
                      {refreshData ? (
                        cancelledTasks.length > 0 ? (
                          <div className='mt-2'>
                            {cancelledTasks.map((item) => (
                              <div
                                key={item?._id}
                                className={`bg-white hover:bg-gray-300 duration-200 mx-2 mb-2 px-3 py-2 cursor-default rounded-sm border-gray-100 flex-col ${
                                  item?.assignee._id === state.user._id
                                    ? item?.createdBy._id === state.user._id
                                      ? "border-l-8 border-self-assigned"
                                      : "border-l-8 border-assigned-to-me"
                                    : ""
                                } ${
                                  item?.createdBy._id === state.user._id &&
                                  item?.assignee._id !== state.user._id
                                    ? "border-l-8 border-assigned-by-me"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  navigate("/servicetask/" + item?._id);
                                }}>
                                <div className='flex justify-between'>
                                  <div className='flex'>
                                    <span
                                      className={`font-semibold text-sm ${
                                        item?.assignee._id === state.user._id
                                          ? item?.createdBy._id ===
                                            state.user._id
                                            ? "text-self-assigned"
                                            : "text-assigned-to-me"
                                          : ""
                                      } ${
                                        item?.createdBy._id ===
                                          state.user._id &&
                                        item?.assignee._id !== state.user._id
                                          ? "text-assigned-by-me"
                                          : ""
                                      } mr-2`}>
                                      #{item?.serviceTaskID}
                                    </span>
                                    {/* {renderStatus(item?.status)} */}
                                  </div>
                                  <span className='font-semibold text-xs text-gray-dark text-right'>
                                    Service - #
                                    {item?.serviceTicketId?.serviceTicketID +
                                      (item?.serviceTicketId?.addressBookId
                                        ? " | " +
                                          item?.serviceTicketId?.addressBookId
                                            ?.prefix +
                                          ". " +
                                          item?.serviceTicketId?.addressBookId
                                            ?.firstName
                                        : "")}
                                  </span>
                                </div>
                                <div className='flex justify-between py-1'>
                                  <span className='font-semibold text-sm text-gray-dark'>
                                    {item?.name}
                                  </span>
                                </div>
                                <div className='flex justify-between mt-1'>
                                  <div className='flex mt-1'>
                                    <span className='font-semibold text-xs '>
                                      {moment
                                        .utc(item?.dueDate)
                                        .local()
                                        .format("yyyy-MM-DD HH:mm")}
                                    </span>
                                  </div>
                                  <div className='flex space-x-2 pb-1'>
                                    <img
                                      src={
                                        item?.createdBy?.avatar
                                          ? item?.createdBy?.avatar
                                          : "/assets/images/user.png"
                                      }
                                      alt='User'
                                      title={
                                        "Reportee - " +
                                        item?.createdBy?.fullname
                                      }
                                      referrerPolicy='no-referrer'
                                      className='h-7 w-7 rounded-full ring-1 ring-yellow-2'
                                    />
                                    <img
                                      src={
                                        item?.assignee?.avatar
                                          ? item?.assignee?.avatar
                                          : "/assets/images/user.png"
                                      }
                                      alt='User'
                                      title={
                                        "Assignee - " + item?.assignee?.fullname
                                      }
                                      referrerPolicy='no-referrer'
                                      className='h-7 w-7 rounded-full ring-1 ring-yellow-2'
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className='font-semibold'></div>
                        )
                      ) : (
                        <span className='mt-1 block w-full px-3 text-sm'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-gray-100 h-6 rounded-sm '></div>
                          </div>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='pb-4 py-6 sm:px-0 block sm:hidden'>
              <div className='shadow-lg'>
                <div className='flex-col pb-2 bg-gray-50'>
                  <div className='p-4'>
                    <div className='flex-col'>
                      <div className='flex py-1 px-2 text-sm font-semibold'>
                        <div className='w-3 h-3 rounded-sm mt-1 mr-2 bg-assigned-to-me'></div>
                        <p className='mt-0.25 text-assigned-to-me'>
                          Assigned To Me
                        </p>
                      </div>
                      <div className='flex py-1 px-2 text-sm font-semibold'>
                        <div className='w-3 h-3 rounded-sm mt-1 mr-2 bg-assigned-by-me'></div>
                        <p className='mt-0.25 text-assigned-by-me'>
                          Assigned By Me
                        </p>
                      </div>
                      <div className='flex py-1 px-2 text-sm font-semibold'>
                        <div className='w-3 h-3 rounded-sm mt-1 mr-2 bg-self-assigned'></div>
                        <p className='mt-0.25 text-self-assigned'>
                          Self Assigned
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className='flex-col space-y-4 px-3 justify-between overflow-x-auto'>
                    {todaysTasks.length > 0 && (
                      <div className='flex-col pb-4'>
                        <div className=''>
                          <h2 className='ml-1 text-sm font-semibold leading-3 text-gray-dark sm:text-lg'>
                            Today's Spotlight
                          </h2>
                        </div>
                        <div className='flex-col space-y-2 w-full px-4 mt-4'>
                          {todaysTasks.map((item) => (
                            <div
                              key={item._id}
                              className={`flex space-x-2 justify-between px-3 py-2 bg-white hover:bg-gray-300 duration-300 rounded-md hover:rounded-sm shadow-md overflow-x-auto ${
                                item?.assignee._id === state.user._id
                                  ? item?.createdBy._id === state.user._id
                                    ? "border-l-8 border-self-assigned"
                                    : "border-l-8 border-assigned-to-me"
                                  : ""
                              } ${
                                item?.createdBy._id === state.user._id &&
                                item?.assignee._id !== state.user._id
                                  ? "border-l-8 border-assigned-by-me"
                                  : ""
                              }`}
                              onClick={(e) => {
                                navigate("/servicetask/" + item._id);
                              }}>
                              <div className=''>
                                <span
                                  className={`font-semibold text-sm ${
                                    item?.assignee._id === state.user._id
                                      ? item?.createdBy._id === state.user._id
                                        ? "text-self-assigned"
                                        : "text-assigned-to-me"
                                      : ""
                                  } ${
                                    item?.createdBy._id === state.user._id &&
                                    item?.assignee._id !== state.user._id
                                      ? "text-assigned-by-me"
                                      : ""
                                  } mr-2`}>
                                  #{item.serviceTaskID}
                                </span>
                                <span className='font-semibold text-sm text-gray-dark cursor-default'>
                                  {item.name.slice(0, 50)}
                                </span>
                              </div>
                              <div className='flex justify-end font-semibold text-xs rounded-md text-gray-dark'>
                                <span className='mt-1'>
                                  {item.dueDate
                                    ?.toString()
                                    .slice(0, 16)
                                    .replace("T", " ")}
                                </span>
                                {moment(item.dueDate.toString().slice(0, 19))
                                  // .local()
                                  .diff(Date.now(), "minutes") < 0 &&
                                  !item.status.includes(
                                    "DONE",
                                    "CANCELLED",
                                  ) && (
                                    <div className='font-semibold pl-2 animate-pulse rounded-md leading-5'>
                                      <span className='bg-red-100 text-red-200 text-xs font-semibold px-1.5 py-0.5 rounded dark:bg-red-800'>
                                        OVERDUE
                                      </span>
                                    </div>
                                  )}
                                <div className='ml-2 mt-0.5'>
                                  {renderStatus(item.status)}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    <div className='flex-col w-full bg-yellow-50 py-3'>
                      <div className='text-sm font-semibold text-gray-700 px-4'>
                        NEW
                      </div>
                      {refreshData ? (
                        newTasks.length > 0 ? (
                          <div className='mt-2'>
                            {newTasks.map((item) => (
                              <div
                                key={item?._id}
                                className={`bg-white hover:bg-gray-300 duration-200 mx-2 mb-2 px-3 py-2 cursor-default rounded-sm border-gray-100 flex-col ${
                                  item?.assignee._id === state.user._id
                                    ? item?.createdBy._id === state.user._id
                                      ? "border-l-8 border-self-assigned"
                                      : "border-l-8 border-assigned-to-me"
                                    : ""
                                } ${
                                  item?.createdBy._id === state.user._id &&
                                  item?.assignee._id !== state.user._id
                                    ? "border-l-8 border-assigned-by-me"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  navigate("/servicetask/" + item?._id);
                                }}>
                                <div className='flex justify-between'>
                                  <div className='flex'>
                                    <span
                                      className={`font-semibold text-sm ${
                                        item?.assignee._id === state.user._id
                                          ? item?.createdBy._id ===
                                            state.user._id
                                            ? "text-self-assigned"
                                            : "text-assigned-to-me"
                                          : ""
                                      } ${
                                        item?.createdBy._id ===
                                          state.user._id &&
                                        item?.assignee._id !== state.user._id
                                          ? "text-assigned-by-me"
                                          : ""
                                      } mr-2`}>
                                      #{item?.serviceTaskID}
                                    </span>
                                    {/* {renderStatus(item?.status)} */}
                                  </div>
                                  <span className='font-semibold text-xs text-gray-dark text-right'>
                                    Service - #
                                    {item?.serviceTicketId?.serviceTicketID +
                                      (item?.serviceTicketId?.addressBookId
                                        ? " | " +
                                          item?.serviceTicketId?.addressBookId
                                            ?.prefix +
                                          ". " +
                                          item?.serviceTicketId?.addressBookId
                                            ?.firstName
                                        : "")}
                                  </span>
                                </div>
                                <div className='flex justify-between py-1'>
                                  <span className='font-semibold text-sm text-gray-dark'>
                                    {item?.name}
                                  </span>
                                </div>
                                <div className='flex justify-between mt-1'>
                                  <div className='flex mt-1'>
                                    <span className='font-semibold text-xs '>
                                      {moment
                                        .utc(item?.dueDate)
                                        .local()
                                        .format("yyyy-MM-DD HH:mm")}
                                    </span>
                                    {moment(
                                      Date(item?.dueDate)?.slice(0, 16),
                                    ).diff(Date.now(), "days") < 0 && (
                                      <img
                                        className={`h-5 w-5 ml-1.5`}
                                        src={`/assets/icons/task-overdue.png`}
                                        alt='Task Overdue'
                                      />
                                    )}
                                  </div>
                                  <div className='flex space-x-2 pb-1'>
                                    <img
                                      src={
                                        item?.createdBy?.avatar
                                          ? item?.createdBy?.avatar
                                          : "/assets/images/user.png"
                                      }
                                      alt='User'
                                      title={
                                        "Reportee - " +
                                        item?.createdBy?.fullname
                                      }
                                      referrerPolicy='no-referrer'
                                      className='h-7 w-7 rounded-full ring-1 ring-yellow-2'
                                    />
                                    <img
                                      src={
                                        item?.assignee?.avatar
                                          ? item?.assignee?.avatar
                                          : "/assets/images/user.png"
                                      }
                                      alt='User'
                                      title={
                                        "Assignee - " + item?.assignee?.fullname
                                      }
                                      referrerPolicy='no-referrer'
                                      className='h-7 w-7 rounded-full ring-1 ring-yellow-2'
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className='font-semibold'></div>
                        )
                      ) : (
                        <span className='mt-1 block w-full px-3 text-sm'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-gray-100 h-6 rounded-sm '></div>
                          </div>
                        </span>
                      )}
                    </div>
                    <div className='flex-col w-full bg-yellow-50 py-3'>
                      <div className='text-sm font-semibold text-gray-700 px-4'>
                        ASSIGNED
                      </div>
                      {refreshData ? (
                        assignedTasks.length > 0 ? (
                          <div className='mt-2'>
                            {assignedTasks.map((item) => (
                              <div
                                key={item?._id}
                                className={`bg-white hover:bg-gray-300 duration-200 mx-2 mb-2 px-3 py-2 cursor-default rounded-sm border-gray-100 flex-col ${
                                  item?.assignee._id === state.user._id
                                    ? item?.createdBy._id === state.user._id
                                      ? "border-l-8 border-self-assigned"
                                      : "border-l-8 border-assigned-to-me"
                                    : ""
                                } ${
                                  item?.createdBy._id === state.user._id &&
                                  item?.assignee._id !== state.user._id
                                    ? "border-l-8 border-assigned-by-me"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  navigate("/servicetask/" + item?._id);
                                }}>
                                <div className='flex justify-between'>
                                  <div className='flex'>
                                    <span
                                      className={`font-semibold text-sm ${
                                        item?.assignee._id === state.user._id
                                          ? item?.createdBy._id ===
                                            state.user._id
                                            ? "text-self-assigned"
                                            : "text-assigned-to-me"
                                          : ""
                                      } ${
                                        item?.createdBy._id ===
                                          state.user._id &&
                                        item?.assignee._id !== state.user._id
                                          ? "text-assigned-by-me"
                                          : ""
                                      } mr-2`}>
                                      #{item?.serviceTaskID}
                                    </span>
                                    {/* {renderStatus(item?.status)} */}
                                  </div>
                                  <span className='font-semibold text-xs text-gray-dark text-right'>
                                    Service - #
                                    {item?.serviceTicketId?.serviceTicketID +
                                      (item?.serviceTicketId?.addressBookId
                                        ? " | " +
                                          item?.serviceTicketId?.addressBookId
                                            ?.prefix +
                                          ". " +
                                          item?.serviceTicketId?.addressBookId
                                            ?.firstName
                                        : "")}
                                  </span>
                                </div>
                                <div className='flex justify-between py-1'>
                                  <span className='font-semibold text-sm text-gray-dark'>
                                    {item?.name}
                                  </span>
                                </div>
                                <div className='flex justify-between mt-1'>
                                  <div className='flex mt-1'>
                                    <span className='font-semibold text-xs '>
                                      {moment
                                        .utc(item?.dueDate)
                                        .local()
                                        .format("yyyy-MM-DD HH:mm")}
                                    </span>
                                    {moment(
                                      Date(item?.dueDate)?.slice(0, 16),
                                    ).diff(Date.now(), "days") < 0 && (
                                      <img
                                        className={`h-5 w-5 ml-1.5`}
                                        src={`/assets/icons/task-overdue.png`}
                                        alt='Task Overdue'
                                      />
                                    )}
                                  </div>
                                  <div className='flex space-x-2 pb-1'>
                                    <img
                                      src={
                                        item?.createdBy?.avatar
                                          ? item?.createdBy?.avatar
                                          : "/assets/images/user.png"
                                      }
                                      alt='User'
                                      title={
                                        "Reportee - " +
                                        item?.createdBy?.fullname
                                      }
                                      referrerPolicy='no-referrer'
                                      className='h-7 w-7 rounded-full ring-1 ring-yellow-2'
                                    />
                                    <img
                                      src={
                                        item?.assignee?.avatar
                                          ? item?.assignee?.avatar
                                          : "/assets/images/user.png"
                                      }
                                      alt='User'
                                      title={
                                        "Assignee - " + item?.assignee?.fullname
                                      }
                                      referrerPolicy='no-referrer'
                                      className='h-7 w-7 rounded-full ring-1 ring-yellow-2'
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className='font-semibold'></div>
                        )
                      ) : (
                        <span className='mt-1 block w-full px-3 text-sm'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-gray-100 h-6 rounded-sm '></div>
                          </div>
                        </span>
                      )}
                    </div>
                    <div className='flex-col w-full bg-yellow-50 py-3'>
                      <div className='text-sm font-semibold text-gray-700 px-4'>
                        IN PROCESS
                      </div>
                      {refreshData ? (
                        inServiceTasks.length > 0 ? (
                          <div className='mt-2'>
                            {inServiceTasks.map((item) => (
                              <div
                                key={item?._id}
                                className={`bg-white hover:bg-gray-300 duration-200 mx-2 mb-2 px-3 py-2 cursor-default rounded-sm border-gray-100 flex-col ${
                                  item?.assignee._id === state.user._id
                                    ? item?.createdBy._id === state.user._id
                                      ? "border-l-8 border-self-assigned"
                                      : "border-l-8 border-assigned-to-me"
                                    : ""
                                } ${
                                  item?.createdBy._id === state.user._id &&
                                  item?.assignee._id !== state.user._id
                                    ? "border-l-8 border-assigned-by-me"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  navigate("/servicetask/" + item?._id);
                                }}>
                                <div className='flex justify-between'>
                                  <div className='flex'>
                                    <span
                                      className={`font-semibold text-sm ${
                                        item?.assignee._id === state.user._id
                                          ? item?.createdBy._id ===
                                            state.user._id
                                            ? "text-self-assigned"
                                            : "text-assigned-to-me"
                                          : ""
                                      } ${
                                        item?.createdBy._id ===
                                          state.user._id &&
                                        item?.assignee._id !== state.user._id
                                          ? "text-assigned-by-me"
                                          : ""
                                      } mr-2`}>
                                      #{item?.serviceTaskID}
                                    </span>
                                    {/* {renderStatus(item?.status)} */}
                                  </div>
                                  <span className='font-semibold text-xs text-gray-dark text-right'>
                                    Service - #
                                    {item?.serviceTicketId?.serviceTicketID +
                                      (item?.serviceTicketId?.addressBookId
                                        ? " | " +
                                          item?.serviceTicketId?.addressBookId
                                            ?.prefix +
                                          ". " +
                                          item?.serviceTicketId?.addressBookId
                                            ?.firstName
                                        : "")}
                                  </span>
                                </div>
                                <div className='flex justify-between py-1'>
                                  <span className='font-semibold text-sm text-gray-dark'>
                                    {item?.name}
                                  </span>
                                </div>
                                <div className='flex justify-between mt-1'>
                                  <div className='flex mt-1'>
                                    <span className='font-semibold text-xs '>
                                      {moment
                                        .utc(item?.dueDate)
                                        .local()
                                        .format("yyyy-MM-DD HH:mm")}
                                    </span>
                                    {moment(
                                      Date(item?.dueDate)?.slice(0, 16),
                                    ).diff(Date.now(), "days") < 0 && (
                                      <img
                                        className={`h-5 w-5 ml-1.5`}
                                        src={`/assets/icons/task-overdue.png`}
                                        alt='Task Overdue'
                                      />
                                    )}
                                  </div>
                                  <div className='flex space-x-2 pb-1'>
                                    <img
                                      src={
                                        item?.createdBy?.avatar
                                          ? item?.createdBy?.avatar
                                          : "/assets/images/user.png"
                                      }
                                      alt='User'
                                      title={
                                        "Reportee - " +
                                        item?.createdBy?.fullname
                                      }
                                      referrerPolicy='no-referrer'
                                      className='h-7 w-7 rounded-full ring-1 ring-yellow-2'
                                    />
                                    <img
                                      src={
                                        item?.assignee?.avatar
                                          ? item?.assignee?.avatar
                                          : "/assets/images/user.png"
                                      }
                                      alt='User'
                                      title={
                                        "Assignee - " + item?.assignee?.fullname
                                      }
                                      referrerPolicy='no-referrer'
                                      className='h-7 w-7 rounded-full ring-1 ring-yellow-2'
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className='font-semibold'></div>
                        )
                      ) : (
                        <span className='mt-1 block w-full px-3 text-sm'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-gray-100 h-6 rounded-sm '></div>
                          </div>
                        </span>
                      )}
                    </div>
                    <div className='flex-col w-full bg-yellow-50 py-3'>
                      <div className='text-sm font-semibold text-gray-700 px-4'>
                        DONE
                      </div>
                      {refreshData ? (
                        doneTasks.length > 0 ? (
                          <div className='mt-2'>
                            {doneTasks.map((item) => (
                              <div
                                key={item?._id}
                                className={`bg-white hover:bg-gray-300 duration-200 mx-2 mb-2 px-3 py-2 cursor-default rounded-sm border-gray-100 flex-col ${
                                  item?.assignee._id === state.user._id
                                    ? item?.createdBy._id === state.user._id
                                      ? "border-l-8 border-self-assigned"
                                      : "border-l-8 border-assigned-to-me"
                                    : ""
                                } ${
                                  item?.createdBy._id === state.user._id &&
                                  item?.assignee._id !== state.user._id
                                    ? "border-l-8 border-assigned-by-me"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  navigate("/servicetask/" + item?._id);
                                }}>
                                <div className='flex justify-between'>
                                  <div className='flex'>
                                    <span
                                      className={`font-semibold text-sm ${
                                        item?.assignee._id === state.user._id
                                          ? item?.createdBy._id ===
                                            state.user._id
                                            ? "text-self-assigned"
                                            : "text-assigned-to-me"
                                          : ""
                                      } ${
                                        item?.createdBy._id ===
                                          state.user._id &&
                                        item?.assignee._id !== state.user._id
                                          ? "text-assigned-by-me"
                                          : ""
                                      } mr-2`}>
                                      #{item?.serviceTaskID}
                                    </span>
                                    {/* {renderStatus(item?.status)} */}
                                  </div>
                                  <span className='font-semibold text-xs text-gray-dark text-right'>
                                    Service - #
                                    {item?.serviceTicketId?.serviceTicketID +
                                      (item?.serviceTicketId?.addressBookId
                                        ? " | " +
                                          item?.serviceTicketId?.addressBookId
                                            ?.prefix +
                                          ". " +
                                          item?.serviceTicketId?.addressBookId
                                            ?.firstName
                                        : "")}
                                  </span>
                                </div>
                                <div className='flex justify-between py-1'>
                                  <span className='font-semibold text-sm text-gray-dark'>
                                    {item?.name}
                                  </span>
                                </div>
                                <div className='flex justify-between mt-1'>
                                  <div className='flex mt-1'>
                                    <span className='font-semibold text-xs '>
                                      {moment
                                        .utc(item?.dueDate)
                                        .local()
                                        .format("yyyy-MM-DD HH:mm")}
                                    </span>
                                    {moment(
                                      Date(item?.dueDate)?.slice(0, 16),
                                    ).diff(Date.now(), "days") < 0 && (
                                      <img
                                        className={`h-5 w-5 ml-1.5`}
                                        src={`/assets/icons/task-overdue.png`}
                                        alt='Task Overdue'
                                      />
                                    )}
                                  </div>
                                  <div className='flex space-x-2 pb-1'>
                                    <img
                                      src={
                                        item?.createdBy?.avatar
                                          ? item?.createdBy?.avatar
                                          : "/assets/images/user.png"
                                      }
                                      alt='User'
                                      title={
                                        "Reportee - " +
                                        item?.createdBy?.fullname
                                      }
                                      referrerPolicy='no-referrer'
                                      className='h-7 w-7 rounded-full ring-1 ring-yellow-2'
                                    />
                                    <img
                                      src={
                                        item?.assignee?.avatar
                                          ? item?.assignee?.avatar
                                          : "/assets/images/user.png"
                                      }
                                      alt='User'
                                      title={
                                        "Assignee - " + item?.assignee?.fullname
                                      }
                                      referrerPolicy='no-referrer'
                                      className='h-7 w-7 rounded-full ring-1 ring-yellow-2'
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className='font-semibold'></div>
                        )
                      ) : (
                        <span className='mt-1 block w-full px-3 text-sm'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-gray-100 h-6 rounded-sm '></div>
                          </div>
                        </span>
                      )}
                    </div>
                    <div className='flex-col w-full bg-yellow-50 py-3'>
                      <div className='text-sm font-semibold text-gray-700 px-4'>
                        CANCELLED
                      </div>
                      {refreshData ? (
                        cancelledTasks.length > 0 ? (
                          <div className='mt-2'>
                            {cancelledTasks.map((item) => (
                              <div
                                key={item?._id}
                                className={`bg-white hover:bg-gray-300 duration-200 mx-2 mb-2 px-3 py-2 cursor-default rounded-sm border-gray-100 flex-col ${
                                  item?.assignee._id === state.user._id
                                    ? item?.createdBy._id === state.user._id
                                      ? "border-l-8 border-self-assigned"
                                      : "border-l-8 border-assigned-to-me"
                                    : ""
                                } ${
                                  item?.createdBy._id === state.user._id &&
                                  item?.assignee._id !== state.user._id
                                    ? "border-l-8 border-assigned-by-me"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  navigate("/servicetask/" + item?._id);
                                }}>
                                <div className='flex justify-between'>
                                  <div className='flex'>
                                    <span
                                      className={`font-semibold text-sm ${
                                        item?.assignee._id === state.user._id
                                          ? item?.createdBy._id ===
                                            state.user._id
                                            ? "text-self-assigned"
                                            : "text-assigned-to-me"
                                          : ""
                                      } ${
                                        item?.createdBy._id ===
                                          state.user._id &&
                                        item?.assignee._id !== state.user._id
                                          ? "text-assigned-by-me"
                                          : ""
                                      } mr-2`}>
                                      #{item?.serviceTaskID}
                                    </span>
                                    {/* {renderStatus(item?.status)} */}
                                  </div>
                                  <span className='font-semibold text-xs text-gray-dark text-right'>
                                    Service - #
                                    {item?.serviceTicketId?.serviceTicketID +
                                      (item?.serviceTicketId?.addressBookId
                                        ? " | " +
                                          item?.serviceTicketId?.addressBookId
                                            ?.prefix +
                                          ". " +
                                          item?.serviceTicketId?.addressBookId
                                            ?.firstName
                                        : "")}
                                  </span>
                                </div>
                                <div className='flex justify-between py-1'>
                                  <span className='font-semibold text-sm text-gray-dark'>
                                    {item?.name}
                                  </span>
                                </div>
                                <div className='flex justify-between mt-1'>
                                  <div className='flex mt-1'>
                                    <span className='font-semibold text-xs '>
                                      {moment
                                        .utc(item?.dueDate)
                                        .local()
                                        .format("yyyy-MM-DD HH:mm")}
                                    </span>
                                    {moment(
                                      Date(item?.dueDate)?.slice(0, 16),
                                    ).diff(Date.now(), "days") < 0 && (
                                      <img
                                        className={`h-5 w-5 ml-1.5`}
                                        src={`/assets/icons/task-overdue.png`}
                                        alt='Task Overdue'
                                      />
                                    )}
                                  </div>
                                  <div className='flex space-x-2 pb-1'>
                                    <img
                                      src={
                                        item?.createdBy?.avatar
                                          ? item?.createdBy?.avatar
                                          : "/assets/images/user.png"
                                      }
                                      alt='User'
                                      title={
                                        "Reportee - " +
                                        item?.createdBy?.fullname
                                      }
                                      referrerPolicy='no-referrer'
                                      className='h-7 w-7 rounded-full ring-1 ring-yellow-2'
                                    />
                                    <img
                                      src={
                                        item?.assignee?.avatar
                                          ? item?.assignee?.avatar
                                          : "/assets/images/user.png"
                                      }
                                      alt='User'
                                      title={
                                        "Assignee - " + item?.assignee?.fullname
                                      }
                                      referrerPolicy='no-referrer'
                                      className='h-7 w-7 rounded-full ring-1 ring-yellow-2'
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className='font-semibold'></div>
                        )
                      ) : (
                        <span className='mt-1 block w-full px-3 text-sm'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-gray-100 h-6 rounded-sm '></div>
                          </div>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default ServiceTask;
